import React from 'react';
import { FallbackProfile } from '@finn-no/profilebox';

const Fallback = (): React.ReactElement => (
        <FallbackProfile msg="Noe feilet dessverre i forsøket på å vise kontaktinformasjonen på denne annonsen." />
    );

export default Fallback;
